import IncomeTableGroup from './IncomeTableGroup';

export default IncomeTableGroup;
